import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { verifyToken } from "store/actions/authAction";
import { SpinnerSyncBlock } from "components/Spinner";

export default ComposedComponent => {
  class Authenticate extends Component {
    componentDidMount() {
      this.props.verifyToken();
    }

    render() {
      if (typeof this.props.isAuthenticated === "undefined") {
        return <SpinnerSyncBlock />;
      }

      if (
        typeof this.props.isAuthenticated !== "undefined" &&
        this.props.isAuthenticated === false
      ) {
        return <Redirect to="/" />;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  const mapStateToProps = state => {
    return {
      isAuthenticated: state.auth.isAuthenticated
    };
  };
  return connect(mapStateToProps, { verifyToken })(Authenticate);
};
